// src/components/ProtectedRoute.js
import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';

const API_URL = process.env.REACT_APP_API_URL || 'http://127.0.0.1:8000';

const ProtectedRoute = ({ children, jinshiRequired = false }) => {
  const [authorized, setAuthorized] = useState(null); // null = loading, true/false = decided
  const hasMadeSelection = sessionStorage.getItem('hasMadeSelection');
  const token = localStorage.getItem('token');

  useEffect(() => {
    const checkAuthorization = async () => {
      if (!hasMadeSelection) {
        setAuthorized(false);
        return;
      }

      if (jinshiRequired) {
        try {
          const response = await fetch(`${API_URL}/user/current-level`, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
          });
          const data = await response.json();
          const achievements = data.achievements || {};

          if (achievements.jinshi) {
            setAuthorized(true);
          } else {
            setAuthorized(false);
          }
        } catch (error) {
          console.error('Error checking Jinshi status:', error);
          setAuthorized(false);
        }
      } else {
        setAuthorized(true);
      }
    };

    checkAuthorization();
  }, [hasMadeSelection, token, jinshiRequired]);

  if (authorized === null) {
    return <div>Loading...</div>; // Or a better loading spinner
  }

  if (!authorized) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;

